export const AUTH0_CALLBACK_PATH = '/auth_confirmed';

export const NATIVE_AUTH_CALLBACK_PATH = '/auth_native_callback';

// After redeeming the code the shell loads the root, so this flags the boot that should land on
// LOGIN_SUCCESS_REDIRECT_PATH instead.
export const NATIVE_ULP_PENDING_KEY = 'sage.nativeUlpPending';
export const LOGIN_METHODS = {
    PASSWORDLESS: 'passwordless',
    ULP: 'ulp',
};

export const LOGIN_SUCCESS_REDIRECT_PATH = '/profile/shift?fromLogin=true';

export const SSO_DIRECT_LOGIN_PATH = '/sso/direct-login';

// Restart from / when the callback matches no branch; must land before SageLoader's 5s reload link
export const UNRESOLVED_CALLBACK_GRACE_MS = 1_000;

// Log a stall when the auth loader sees no auth state change for this long
export const AUTH_STALL_WARNING_MS = 15_000;

export const scope =
    'openid profile email app_metadata read:users read:current_user offline_access';

export const authorizationParams = {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope,

    /**
     * This value needs to match what @auth0/auth0-react expects so that the `onRedirectCallback`
     * function is called for both passwordless and ULP login flows
     *
     * See https://github.com/auth0/auth0-react/issues/82#issuecomment-711479502
     */
    redirect_uri: `${window.location.origin}${AUTH0_CALLBACK_PATH}`,
};
